<template>
    <div class="body">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
                <img src="@/assets/mifi/74.jpg" alt="">
            </van-swipe-item>
            <!-- <van-swipe-item>
                <img src="@/assets/wen/2bn.jpg" alt="">
            </van-swipe-item> -->
        </van-swipe>
        <div class="content">
            <div class="weacher">
                <div class="weacher-r">
                    <van-icon name="volume-o" size="22" />
                    <div class="notice-box">系统公告：随身WIFI，您身边的网络管家！</div>
                </div>
            </div>
        </div>
        <div class="banner">
            <div class="l">直属专营店</div>
            <div class="r">品质保障 售后无忧</div>
        </div>

        <!-- 商品列表 -->
        <div class="group">
            <div class="list" v-for="(item, index) in dataList" :key="index"  @click="linkOpen(item)">
                <div class="list-img">
                    <img :src="item.img" alt="">
                </div>
                <div class="list-content">
                    <div class="top">{{ item.shareName }}</div>
                    <div class="type">型号：{{ item.name1 }}</div>
                    <div class="type">网速类型：{{ item.name5 }}</div>
                    <!-- <div class="type">是用场景：{{item.name6}}</div> -->
                    <div class="remark">{{ item.remark }}</div>
                </div>
                <div class="r-btn">
                    <div class="price">￥{{ item.sharePrice }}</div>
                    <div class="btn">立即购买</div>
                </div>
            </div>
        </div>

        <div class="copyRight" @click="goIntroduction">
            <div style="text-align: center;margin:14px 0;">河北先熠科技有限公司</div>
            <div style="text-align: center;margin-bottom:14px;">地址：河北省石家庄市裕华区联邦东方明珠3栋1单元17层1702A</div>
            <div style="text-align: center;margin-bottom:14px;">备案号：冀ICP备2023023715号-4</div>
        </div>

        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <!-- <van-tabbar-item icon="browsing-history-o">官网</van-tabbar-item> -->
                <van-tabbar-item icon="service-o">客服</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>
        <van-popup v-model="show" round position="bottom" :style="{ height: '50%' }" closeable>
            <div class="title-name">扫码QQ联系客服</div>
            <div class="kefu-img">
                <img src="@/assets/kefu/zhu.jpg" alt="">
            </div>
        </van-popup>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog, Swipe, SwipeItem } from "vant";
export default {
    data() {
        return {
            dataList: [
                {
                    img: require('@/assets/mifi/29.png'), //首图
                    imga: require('@/assets/mifi/30.png'),//介绍图
                    imgb: require('@/assets/mifi/31.png'),//介绍图
                    shareName: 'POE交换机监控专用校园网宽带网络交换机',
                    sharePrice: '248.00',
                    remark: "校园网络专属，单台可容10-15人使用！",
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: 'POE',
                    name2: '否',
                    name3: '1900Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '校园',
                    name7: '1900Mbps',
                    name8: '按年',
                },
                {
                    img: require('@/assets/mifi/2.jpg'), //首图
                    imga: require('@/assets/mifi/2a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/2b.jpg'),//介绍图
                    shareName: 'MF11 wifi路由器双频型，家用/网课/直播专用路由',
                    sharePrice: '200.00',
                    remark: "速度快，网络超稳定，直播不卡顿！",
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: 'MF11',
                    name2: '否',
                    name3: '1500Mbps',
                    name4: '否',
                    name5: '2.4G',
                    name6: '家用',
                    name7: '1500Mbps',
                    name8: '按月',
                },
                {
                    img: require('@/assets/mifi/3.jpg'), //首图
                    imga: require('@/assets/mifi/3a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/3b.jpg'),//介绍图
                    shareName: 'TYC随身WIFI内置超强天线家用/商用/直播游戏/8K超清视频',
                    sharePrice: '150.00',
                    remark: "随时随地玩游戏 就选它！",
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: 'TYC',
                    name2: '否',
                    name3: '2500Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '家用/商用/直播',
                    name7: '2500Mbps',
                    name8: '按月',
                },
                {
                    img: require('@/assets/mifi/4.jpg'), //首图
                    imga: require('@/assets/mifi/4a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/64.jpg'),//介绍图
                    shareName: 'MF12 2025款WIFI6改版大套餐随心用办公专属不卡顿',
                    sharePrice: '120.00',
                    remark: "性价比较高！适合小型办公司使用",
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: 'MF12',
                    name2: '否',
                    name3: '2500Mbps',
                    name4: '否',
                    name5: 'WIFI6',
                    name6: '家用/商用/直播',
                    name7: '2500Mbps',
                    name8: '按月',
                },
                {
                    img: require('@/assets/mifi/1.jpg'), //首图
                    imga: require('@/assets/mifi/1a.jpg'),//介绍图
                    imgb: require('@/assets/mifi/65.jpg'),//介绍图
                    shareName: '2025新款上市升级WiFi6全国通用新款无线随身WIFI',
                    sharePrice: '100.00',
                    remark: "新款上市！购买可享优惠！",
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: '新款WIFI6 YP2型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '5G&wifi6',
                    name6: '场景通用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/7.png'), //首图
                    imga: require('@/assets/mifi/8.png'),//介绍图
                    imgb: require('@/assets/mifi/66.jpg'),//介绍图
                    shareName: '全新增强型光猫路由器一体机四口千兆宽带猫无线猫5G猫',
                    remark: "适合学生，家庭内部使用！",
                    sharePrice: '60.00',
                    type: '1',
                    title: 'WIFI设备',

                    name: '雁云',
                    name1: '24款家用YP型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&wifi6',
                    name6: '家用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                // {
                //     img: require('@/assets/mifi/9.png'), //首图
                //     imga: require('@/assets/mifi/10.png'),//介绍图
                //     imgb: require('@/assets/mifi/67.jpg'),//介绍图
                //     shareName: '光猫路由器一体智能无线路由器家用wifi高速穿墙王大功率千兆双频',
                //     sharePrice: '39.9',
                //     type: '1',
                //     title: 'WIFI设备',

                //     name: '雁云',
                //     name1: 'JP1PRO 家用型',
                //     name2: '否',
                //     name3: '1000Mbps',
                //     name4: '否',
                //     name5: '2.4G&5G&wifi6',
                //     name6: '家用',
                //     name7: '1000Mbps',
                //     name8: '按月',
                // },

                {
                    img: require('@/assets/mifi/5.png'), //首图
                    imga: require('@/assets/mifi/6.png'),//介绍图
                    imgb: require('@/assets/mifi/68.jpg'),//介绍图
                    shareName: '千兆路由器穿墙王全屋覆盖，家庭使用专属',
                    sharePrice: '29.90',
                    type: '1',
                    title: 'WIFI设备',
                    remark: "性价比最高！",
                    name: '雁云',
                    name1: 'JP1 家用型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '家用',
                    name7: '1000Mbps',
                    name8: '按月',
                },

                {
                    img: require('@/assets/mifi/60.jpg'), //首图
                    imga: require('@/assets/mifi/61.jpg'),//介绍图
                    imgb: require('@/assets/mifi/70.jpg'),//介绍图
                    shareName: '家用1200M双频路由器，学生网课WIFI路由设备',
                    sharePrice: '19.90',
                    type: '1',
                    title: 'WIFI设备',

                    remark: "家用优选",

                    name: '雁云',
                    name1: 'JP0 家用型',
                    name2: '否',
                    name3: '1000Mbps',
                    name4: '否',
                    name5: '2.4G&5G',
                    name6: '校园',
                    name7: '1000Mbps',
                    name8: '',
                },
                {
                    img: require('@/assets/mifi/62.jpg'), //首图
                    imga: require('@/assets/mifi/63.jpg'),//介绍图
                    imgb: require('@/assets/mifi/71.jpg'),//介绍图
                    shareName: '3米专用路由连接线',
                    sharePrice: '9.00',
                    type: '1',
                    title: 'WIFI设备',

                    remark: "新老用户限时专属优惠！",

                    name: '雁云',
                    name1: '连接线',
                    name2: '否',
                    name3: '无',
                    name4: '否',
                    name5: '2.4G',
                    name6: '家用',
                    name7: '无',
                    name8: '',
                },

            ],
            active: 0,
            wifiList: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            agentId: '',
            vanTab: ['WIFI设备', '设备外设'],
            allLoaded: false,
            show: false,
            title: 'MIFI设备'
        }
    },
    created() {
        this.wifiList = this.dataList.filter(item => item.type === '1')
    },
    methods: {
        goIntroduction() {
            window.location.href = 'https://beian.miit.gov.cn/'
        },
        onClick(name, title) {
            this.title = title
            this.pageNo = 0
            this.getAgentPrechargeListHandler()
            this.wifiList = title === 'MIFI设备' ? this.dataList.filter(item => item.type === '1') : this.dataList.filter(item => item.type === '2')
        },
        getAgentPrechargeListHandler() {
            this.$refs.loadmore.onBottomLoaded();
            this.$nextTick(function () {
                window.scroll(0, 0);
            })
        },
        onChange(data) {
            console.log(data)
            if (data === 1) {
                this.show = true
            } else if (data ===2) {
                this.$router.push({ path: '/yao/userInfo' });
            }
        },
        linkOpen(data) {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/yao/order', query: { p: encodeURI(JSON.stringify(data)) } });
            } else {
                Dialog.confirm({
                    title: "注册提示",
                    message:"请先注册信息后，再进行购买操作。 点击 确定 即可前往注册。"})
                    .then(() => {
                        this.$router.push({ path: '/yao/login' });
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>
<style lang="less" scoped>
* {
    box-sizing: border-box;
}

.body {
    width: 100%;
    box-sizing: border-box;
    background: #f5f5f5;
    padding: 5px;
    position: relative;
    padding-bottom:50px;
}

.my-swipe {
    height: 180px;
    width: 100%;

    .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 180px;
        text-align: center;

        img {
            width: 100%;
            height: 180px;
        }
    }
}

.weacher-r {
    margin-top: 5px;
    height: 48px;
    background: rgb(255, 255, 255);
    border-radius: 5px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .van-icon-volume-o {
        padding: 0 10px;
    }
}

.banner {
    margin-top: 5px;
    padding: 15px;
    color: #fff;
    font-size: 18px;
    border-radius: 5px;
    background: #3c85ed;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .r {
        font-size: 16px;
    }
}

.group {
    margin-top: 8px;
    margin-bottom: 50px;

    .list {
        width: 100%;
        border-radius: 0.5rem;
        background: #fff;
        margin-bottom: 6px;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, .1);
        display: flex;
        align-items: center;
        padding: 12px;

        .list-img {
            width: 120px;
            height: 120px;
            margin-right: 8px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 0.5rem;
            }
        }

        .list-content {
            width: calc(100% - 200px);
        }

        .top {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            margin-bottom: 5px;
        }

        .type {
            font-size: 14px;
            color: #666;
            margin-bottom: 3px;
        }

        .remark {
            font-size: 13px;
            color: #fff;
            padding: 5px 0.2rem;
            background: #3c85ed;
            border-radius: 5px;
        }

        .r-btn {
            width: 70px;
            text-align: center;

            .price {
                font-size: 18px;
                color: #f00;
                font-weight: bold;
                margin-bottom: 5px;
            }

            .btn {
                background: #3c85ed;
                color: #fff;
                font-size: 12px;
                border-radius: 30px;
                border: none;
                padding: 0.25rem 0.5rem;
                position: relative;
            }
        }
    }
}

.title-name {
    text-align: center;
    font-size: 20px;
    margin-top: 30px;
}

.kefu-img {
    width: 260px;
    height: 340px;
    margin: 20px auto;

    img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }
}

.copyRight {
    /* position: absolute; */
    left: 0;
    right: 0;
    margin: auto;
}
</style>